// Vendor imports
const _ = require('lodash')
const { createSelector } = require('reselect')

const EMPTY_NOTICES = []

function createNoticesSelector(maxNotices) {
  return createSelector(
    state => _.get(state, 'toasts.notices', EMPTY_NOTICES),
    notices => notices.slice(0, maxNotices)
  )
}

module.exports = {
  createNoticesSelector
}
